<template>
        <b-row v-if="item" class="template-desc">
          <b-col v-bind="options">
            
                
                <b-row class="mb-4" style="text-align:center">
                    <slot name="imageAndVideo">
                        <!-- Cover with image: prefix -->
                        <img v-if="item.template.cover && item.template.cover.startsWith('image:')" class="landing-image" :src="item.template.cover.replace('image:', '')" alt="img" />
                        <!-- Cover with b-icon: prefix -->
                        <div v-else-if="item.template.cover && item.template.cover.startsWith('b-icon:')" class="landing-icon">
                            <b-icon :icon="item.template.cover.replace('b-icon:', '')" font-scale="5"></b-icon>
                        </div>
                        <!-- Plain cover (backwards compatibility) -->
                        <img v-else-if="item.template.cover" class="landing-image" :src="item.template.cover" alt="img" />
                        <!-- No cover -->
                        <div v-else class="landing-icon">
                            <b-icon icon="file-earmark-text" font-scale="5"></b-icon>
                        </div>
                        <b-col sm="12" v-if="item.template.video">
                            <b-button class="landing-button" variant="primary" @click="showVideo = true" block>{{ $t('watchVideo') }}</b-button>
                            <main-dialog hide-header hide-footer v-model="showVideo">
                            <iframe width="100%" style="border:none"
                            allowfullscreen
                            height="250"
                            :src="item.template.video">
                            </iframe>
                            </main-dialog>

                        </b-col>
                    </slot>
                    <slot name="buttons"></slot>
                </b-row>
          </b-col>
          <b-col v-if="item.template.name">
            <div>
              <h2>{{ this.translate(item.template.label) }} </h2> 
              <b-badge v-if="item.template.upgrade_from" variant="warning"> {{ $t('templateIsUpgrade') }} </b-badge> 
              <b-badge v-if="item.template.upgrade_to" variant="warning"> {{ $t('templateIsUpgradable') }} </b-badge>
            </div> 
            
            <p><small style="color:#ccc">{{ this.translate(item.template.description) }}</small></p>

            <template v-if="item.template.upgrade_to">
              <h5>{{ $t('templateIsUpgrade') }}:</h5>
              <b-button variant="success" size="sm" @click="$emit('upgradeClicked', item.template.upgrade_to_template)">{{ this.translate(item.template.upgrade_to_template.label) }}</b-button>
            </template>
  
            <h5 class="mt-5">{{ $t('includes') }}:</h5>
  
            <ul>
              <li v-if="item.template.trial_period !== null"> {{ $t('trialPeriod') }} <b>{{ item.template.trial_period }} {{ $t('days') }}</b></li>
            </ul>
  
            <div v-for="(products, group) in item.groupVisibleProducts()" :key="group">
                <p v-if="products.length > 0"><b>{{ $t(`templateProducts.${group}`) }}:</b></p>
                <ul>
                    
                    <li v-for="product in products" :key="product.id">
                        <h5>{{  product.name }} </h5> 
                        <small style="color:#ccc"> {{ product.description }} </small>
                        <br />
                        <br />
                        <small style="color:#ccc"> {{ product.pricing_description }} </small>
                    </li>
                </ul>
            </div>
          </b-col>
        </b-row>
  
        <b-row v-else>
          <b-col sm="3">
            <b-skeleton width="100%" height="250px" animation="throb" />
          </b-col>
          <b-col>
            <h2><b-skeleton width="200px" height="30px" animation="throb"/></h2>
            <p><b-skeleton animation="throb"/></p>
          </b-col>
        </b-row>
  </template>
  
  <style scoped lang="scss">
  @import "@/assets/scss/style.scss";
  .form-control {
    background: inherit;
    color: inherit;
    border: 1px solid #e4e7ea;
    border-right: 0px;
  }
  
  .template-desc {
    box-shadow: rgb(0 0 0 / 25%) 0px 25px 50px -12px;
    border: none;
  }
  
  img.landing-image {
    width: 100%;
    height: 300px;
    object-fit: cover;
    padding: 10px;
    margin: 0 auto;
  }
  
  .landing-icon {
    width: 100%;
    height: 300px;
    padding: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-secondary);
  }
  
  .landing-button {
    margin-top: 20px;
  }
  
  .landing-page.container {
    margin-top: 20px;
    margin-bottom: 50px;
  }

  small {
    font-size: 90%;
  }
  </style>
  
  <script>
  
  import Template from "../../lib/Template";
  import { toUpper, get } from "lodash"
  import Price from "@/plugins/protokol/lib/Price"
  
  export default {
    name: "Description",
    props: {
        item: {
            type: Template
        },

        type: {
            type: String
        }
    },
    data: function () {
      return {
        showVideo: false
      }
    },
  
    computed: {
      locale() {
          if (this.$route.query.lang) {
            return this.$route.query.lang
          }
  
          return this.$store.getters.getLocale
      },
  
      currency() {
        const country = get(this.$store.getters.getUser, 'settings.billing_address.country', null)
        const price = new Price(
          country,
          this.locale
        )

        let c = this.$route.query.currency || price.getCurrency()

        return toUpper(c)
      },

      options() {
         return {
            cols: this.type == 'single' ? 12 : 4,
            ...this.$attrs
         }
      }
    }, 
  
    methods: {
      translate(label) {
        try {
          return label.locales[this.locale]
        } catch {
          return false
        }
      }
    }
  }
  </script>